import React from "react";
import { LanguageCode } from "../../utils/translations";
import { COLORS } from "../../utils/constants";

interface VideoItem {
  title: string;
  year: number;
}

interface FactCardProps {
  lang: LanguageCode;
  title: string;
  description: string;
  videos: VideoItem[];
  labels: {
    topVideos: string;
  };
}

const FactCard: React.FC<FactCardProps> = ({
  title,
  description,
  videos,
  labels,
}) => {
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        // FIXED: Reduced padding from 32px to 24px
        padding: "24px",
        // FIXED: Softened the shadow so it doesn't bleed into other sections
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        maxWidth: "720px",
        // FIXED: margin: "0 auto" usually adds space; we'll force small vertical gaps
        margin: "10px auto",
        border: "1px solid #edf2f7", // Subtle border for definition without mass
      }}
    >
      <h3
        style={{
          fontSize: "1.5rem", // Slightly smaller for a tighter look
          marginBottom: "0.5rem", // Reduced gap
          marginTop: 0,
          color: "#714B67", // brandPurple for consistency
          fontWeight: 800,
          textAlign: "center",
        }}
      >
        {title}
      </h3>

      <p
        style={{
          fontSize: "0.95rem", // Slimmer text size
          color: "#4A5568",
          marginBottom: "1.2rem",
          lineHeight: "1.4",
          marginTop: 0,
        }}
      >
        {description}
      </p>

      <div style={{ borderTop: "1px solid #f7fafc", paddingTop: "1rem" }}>
        <strong
          style={{
            color: "#017E84",
            fontSize: "0.85rem",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          {labels.topVideos}
        </strong>
        <ul
          style={{
            marginTop: "0.5rem",
            paddingLeft: "20px",
            listStyleType: "disc",
          }}
        >
          {videos.map((v, idx) => (
            <li
              key={idx}
              style={{
                marginBottom: "4px",
                color: "#2D3748",
                fontSize: "0.9rem",
              }}
            >
              {v.title}{" "}
              <span style={{ opacity: 0.6, fontSize: "0.8rem" }}>
                ({v.year})
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FactCard;
